import { PASSWORD_REQUIREMENTS } from './passwordValidatorConstants';

const PASSWORD_VALIDATION_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
const PASSWORD_ALLOWED_CHARACTERS_REGEX =
  /[^[:alnum:]!@#$%^&*~`()_+-=\[\]{};':"\\|,.<>\/?]/;

function validatePasswordConfirmation(
  password: string,
  passwordConfirmation: string
) {
  let errors: string | undefined;

  if (!passwordConfirmation) {
    errors = 'Enter a password';
  } else if (!PASSWORD_VALIDATION_REGEX.test(passwordConfirmation)) {
    errors = PASSWORD_REQUIREMENTS;
  } else if (PASSWORD_ALLOWED_CHARACTERS_REGEX.test(passwordConfirmation)) {
    errors = 'Password contains invalid characters. Enter a valid password';
  } else if (passwordConfirmation !== password) {
    errors = 'Password does not match';
  }

  return errors;
}

export { PASSWORD_VALIDATION_REGEX, PASSWORD_ALLOWED_CHARACTERS_REGEX };

export function validatePassword(
  password: string,
  passwordConfirmation: string
) {
  const errors: {
    password?: string;
    password_confirmation?: string;
  } = {};

  if (!password) {
    errors.password = 'Enter a password';
  } else if (!PASSWORD_VALIDATION_REGEX.test(password)) {
    errors.password = PASSWORD_REQUIREMENTS;
  } else if (PASSWORD_ALLOWED_CHARACTERS_REGEX.test(password)) {
    errors.password =
      'Password contains invalid characters. Enter a valid password';
  }

  if (passwordConfirmation) {
    errors.password_confirmation = validatePasswordConfirmation(
      password,
      passwordConfirmation
    );
  }

  return errors;
}
